import { useTextCardForm } from "@/components/shared/forms/text-card-form";
import type { CommonColor } from "@stackje/common/config";

export function AddTextCard(defaultType: "text1", defaultColors: CommonColor) {
  const { formContent, previewContent, shuffleColors, handleSubmit } = useTextCardForm({
    initialData: {
      title: "",
      subtitle: "",
      type: defaultType,
      colors: defaultColors,
    },
    mode: "add",
  });

  return {
    formContent,
    previewContent,
    shuffleColors,
    handleSubmit,
  };
}
